<ng-container *ngIf="mode === 'embedded'">
  <ng-container *ngTemplateOutlet="triggerTemplate"></ng-container>
</ng-container>

<span
  class="static-label"
  [id]="staticLabelId"
  [class.is-error]="isError"
  *ngIf="mode === 'standalone' && isLabelAbove && !!label"
>
  {{ label }}
  <span class="required-marker" *ngIf="required" aria-hidden="true">*</span>
</span>

<label
  *ngIf="mode === 'standalone'"
  #labelRef
  [for]="name"
  class="label"
  [ngClass]="{
    'fixed-height': isMultiple === false,
    disabled: isDisabled,
    'is-error': isError,
    'add-on-right-extra-padding': showAddOn,
  }"
>
  <span
    *ngIf="!isLabelAbove"
    [ngClass]="{
      'label-text': true,
      'label-text-top': hasValue,
      'is-error': isError,
    }"
  >
    {{ label }}
    <span class="required-marker" *ngIf="required" aria-hidden="true">*</span>
  </span>

  <app-pill
    *ngFor="let option of selectedOptions"
    [isRemovable]="!isDisabled"
    (handleRemove)="handleRemove(option)"
  >
    {{ option.selectedName ?? option.name }}
  </app-pill>

  <input
    #inputRef
    type="text"
    [id]="name"
    class="input"
    role="combobox"
    aria-autocomplete="list"
    [attr.aria-expanded]="isPanelOpen"
    [attr.aria-controls]="isPanelOpen ? panelId + '-listbox' : null"
    [attr.aria-activedescendant]="activeOptionId"
    [attr.aria-labelledby]="staticLabelId"
    [attr.aria-required]="required || null"
    [attr.aria-invalid]="isError"
    (input)="handleChange($event)"
    (keydown)="handleKeydown($event)"
    [placeholder]="placeholder"
    [disabled]="isDisabled"
    (blur)="handleInputBlur()"
    (focus)="handleInputFocus()"
    [value]="inputValue"
  />
  <div *ngIf="showAddOn" class="add-on-right">
    <ng-container
      *ngIf="showAddOnIcon; else closeButton"
      [ngTemplateOutlet]="addOnRightTemplate"
    ></ng-container>
    <ng-template #closeButton>
      <app-button
        variant="ghost-primary"
        size="circle-small"
        (click)="removeButtonClick()"
      >
        <app-icon>close</app-icon>
      </app-button>
    </ng-template>
  </div>
</label>
<div
  *ngIf="helperText && mode === 'standalone'"
  class="helper-text"
  [ngClass]="{ 'is-error': isError }"
>
  {{ helperText }}
</div>

<ng-template #templateRef>
  <div
    class="options"
    role="listbox"
    [attr.id]="panelId + '-listbox'"
    [ngClass]="{
      'options-with-description': showDescriptionBox,
      'options--embedded': mode === 'embedded',
    }"
  >
    <ng-container *ngIf="filteredOptions.length > 0">
      <div
        class="options-list"
        [ngClass]="{
          'has-description': showDescriptionBox,
        }"
      >
        <div
          #optionRef
          *ngFor="let option of filteredOptions; let i = index"
          class="option"
          role="option"
          [attr.id]="panelId + '-option-' + i"
          [attr.aria-selected]="
            keepPanelOpenOnSelect ? isOptionSelected(option) : i === activeIndex
          "
          [attr.aria-disabled]="option.noClick || null"
          (mousedown)="$event.preventDefault()"
          (click)="handleOptionClick(option)"
          [ngClass]="{
            'no-click': option.noClick,
            'option--active': i === activeIndex,
            'option--selected': showAsSelected(option),
          }"
          (mouseover)="setHoveredOption(option)"
        >
          <ng-container
            *ngIf="optionTemplate; else defaultOption"
            [ngTemplateOutlet]="optionTemplate"
            [ngTemplateOutletContext]="{ $implicit: option }"
          ></ng-container>
          <ng-template #defaultOption>
            <app-status-signal
              *ngIf="option.status"
              [active]="option.status.active"
              [tooltip]="option.status.tooltip"
            ></app-status-signal>
            <span class="option-name">{{ option.name }}</span>
          </ng-template>
          <app-icon *ngIf="showAsSelected(option)" class="option-check">
            check
          </app-icon>
        </div>
      </div>
      <div *ngIf="showDescriptionBox" class="description-container">
        {{ hoveredOption?.description ?? '' }}
      </div>
    </ng-container>

    <div *ngIf="filteredOptions.length === 0 && !isLoading" class="no-options">
      <ng-container
        *ngIf="emptyOptionsTemplate; else emptyMessageTemplate"
        [ngTemplateOutlet]="emptyOptionsTemplate"
      ></ng-container>
      <ng-template #emptyMessageTemplate>
        {{ emptyMessage }}
      </ng-template>
    </div>

    <div *ngIf="isLoading" class="loading-container">
      <app-progress-spinner
        class="spinner"
        [diameter]="25"
      ></app-progress-spinner>
    </div>
  </div>
</ng-template>
